module.exports = __webpack_public_path__ + "img/dafaultHead.2b3122f2.png";